export const Config = {
  apiUrl: 'https://api.servispozitif.com/api/',
  //apiUrl:'http://localhost:22900/api/',
  kurumid: 22450, //prod
  //kurumid: 17899, //test // test@sp.com/1
  production: true,
  isontalepgoster: false,
  istalepgoster: false,
  isMusteriOlusur: true,
  isCihazZorunlu: false,
  isTalepolustur: false,
  istalepadd4: false,
  logintitle : "Talep Yönetim Sistemi",
  logo: "logo.jpeg",
  footer1: "MULTIBRAND © CAKO BÜYÜK MAĞAZACILIK TEKSTİL VE SANAYİ TİCARET LİMİTED ŞİRKETİ - Tüm hakları saklıdır.",
  footer2: ""
};